import instanceAxios from '@/util/axios';

export type TurnRating = 'good' | 'bad';

/**
 * Rates one stored turn.
 *
 * Open to anyone who can use the chat, not just reviewers: the person best placed to say an
 * answer was wrong is the one who just read it. `null` clears a rating, so a misclick is
 * undoable — otherwise the conversation sits in the review queue forever.
 */
export const rateAgentTurn = async (
  conversationId: string,
  seq: number,
  rating: TurnRating | null,
  feedback?: string
): Promise<void> => {
  await instanceAxios.post(`pvt/agent/review/conversations/${conversationId}/turns/${seq}/rate`, {
    rating,
    feedback
  });
};
